<template>
  <DataTable
    class="subscription-data-table"
    v-if="items.length"
    v-bind="$attrs"
    v-on="$listeners"
    :value="items"
    :columns="columns"
    :sticky="false"
  >
    <template #label="{ item }">
      <div class="subscription-data-table__name" v-if="item.addon">
        <span>{{ $t(`addon:${item.addon}`) }}</span>
        <span class="fade text--small" v-if="$te(`addon:${item.addon}:upsell`)">
          <FontAwesomeIcon :icon="['fal', 'long-arrow-right']" /> {{ $t(`addon:${item.addon}:upsell`) }}
        </span>
      </div>

      <div v-else class="subscription-data-table__name">
        <span>{{ item.label }}</span>
        <span class="fade text--small" v-if="item.sublabel">{{ item.sublabel }}</span>
      </div>
    </template>
    <template #status="{ item }">
      <StatusIndicator
        :label="$t(getStatusState(item.status).label)"
        :status="getStatusState(item.status).color"
        class="subscription-data-table__status"
      />
    </template>
    <template #activate="{ item }">
      <div>
        {{ formatDate(item) }}
      </div>
    </template>

    <template #used="{ item }">{{ $t('xOfY', { x: item.used, y: item.total }) }}</template>
    <template #remaining="{ item }">
      <div class="subscription-data-table__remaining">
        <span>{{ item.remaining }}</span>
        <span class="fade text--small" v-if="item.adjusted">{{ $t('includingXAdjusted', { x: item.adjusted }) }}</span>
      </div>
    </template>
    <template #units="{ item }">{{ item.units }}</template>
    <template #unitsPlot="{ item }">{{ item.unitsPlot }}</template>
    <template #shops="{ item }">{{ item.shops }}</template>

    <template #price="{ item }">
      <div v-if="item.priceLabel">{{ item.priceLabel }}</div>

      <div v-else class="data-table__cell-price" :class="{ fade: item.status === 'notActive' }">
        <span>{{ item.priceMonthly.toLocaleString('nb-no') }} /mnd</span>
        <span class="text--small" :class="{ fade: item.status !== 'notActive' }" v-if="item.priceFixed"
          >{{ $t('finishedEstablished') }} {{ item.priceFixed.toLocaleString('nb-no') }} kr</span
        >
      </div>
    </template>
    <template #primary-row-actions="{ item }">
      <slot name="primary" :item="item"><span></span></slot>
    </template>
    <template #secondary-row-actions="{ item, rowIndex }">
      <slot name="secondary" :item="item" :row-index="rowIndex"></slot>
    </template>
  </DataTable>
</template>

<script>
import DataTable from '@/components/DataTable'
import StatusIndicator from '@/components/StatusIndicator'
import moment from 'moment'

const States = {
  active: {
    color: 'success',
    label: 'active',
  },
  cancelled: {
    color: 'error',
    label: 'cancelled',
  },
  notActive: {
    color: 'neutral',
    label: 'notActive',
  },
}

export default {
  props: {
    items: Array,
    columns: Array,
  },
  methods: {
    formatDate(item) {
      return [item.start, item.end]
        .filter(Boolean)
        .map(s => moment(s).format('DD.MM.YYYY'))
        .join(' - ')
    },
    getStatusState(status) {
      return States[status]
    },
  },
  components: {
    DataTable,
    StatusIndicator,
  },
}
</script>

<style lang="scss">
.subscription-data-table {
  overflow-x: auto;
  cursor: initial;
  border-radius: 10px;
  background-color: white;
  padding: 1rem;

  --neutral: #797f85;

  &__name,
  &__remaining {
    display: flex;
    flex-direction: column;
  }

  &__status {
    flex-direction: row-reverse;
    font-size: 1rem;
    gap: 0.5rem;

    .status-indicator__label {
      opacity: 1;
    }
    .status-indicator__dot {
      --size: 10px;
    }
  }

  .kvass-button-group {
    border-radius: var(--border-radius);
    .kvass-button-group__secondary .elder-dropdown__trigger button {
      border-radius: var(--vue-elder-border-radius, 3px);
      border: 1px;
    }
  }

  --data-table-layout: minmax(auto, 200px) minmax(auto, 150px) minmax(auto, 200px) auto minmax(auto, calc(100px - 1rem)) !important;

  &--counts {
    --data-table-layout: minmax(auto, 200px) repeat(var(--data-table-count), minmax(auto, 150px)) auto !important;
  }

  .data-table__cell {
    min-height: 65px;
    font-size: 1rem;
    text-align: left;

    & > svg {
      display: none;
    }

    &-price {
      display: flex;
      flex-direction: column;
      align-items: end;
      span {
        white-space: nowrap;
      }
    }
  }

  .data-table__row {
    &:first-of-type {
      .data-table__cell {
        font-weight: bold;
        border-bottom: 1px solid var(--border-color);
      }
    }
  }

  &.data-table--default {
    .data-table__row:nth-child(odd) {
      .data-table__cell {
        background-color: white;
      }
    }
  }
}
</style>
